import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.common.white,
    // border: '#000',
    // backgroundColor: '#fff',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FFF',
    color: '#474B55',
    border: '1px solid #474B55',
    maxWidth: 'none',
    height: '20px',
    fontFamily: 'MuseoSans',
    fontSize: '1rem',
    fontWeight: '300',
  },
}));

export default CustomTooltip;
